// Sets axios.defaults.baseURL according window.location.origin
const { VUE_APP_API_URL, VUE_APP_API_URL_2 } = process.env;
export default {
  title: "iHuman WebAdmin",
  version: "0001",
  API_URL: VUE_APP_API_URL,
  API_URL_2: VUE_APP_API_URL_2
};
